import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Device = {
  id: string;
  serial_number: string;
  device_name: string;
  owner_name: string;
  is_locked: boolean;
  lock_message_id?: number | null;
  unlock_code: string;
  note: string;
  with_ict: boolean;
  details: {
    has_charger: boolean;
    has_bag: boolean;
    stack_number?: number;
    position_in_stack?: number;
    recall_date?: string;
    return_due_date?: string;
    condition_notes?: string;
  } | null;
  created_at: string;
  updated_at: string;
};

export type DeviceHistory = {
  id: string;
  device_id: string;
  action: string;
  old_value: string;
  new_value: string;
  changed_by: string;
  created_at: string;
};

export type LockAppRun = {
  id: string;
  serial_number: string;
  timestamp: string | null;
  source: string | null;
};